import { render, staticRenderFns } from "./ArchiveOpenOrder.vue?vue&type=template&id=10969765&scoped=true&"
import script from "./ArchiveOpenOrder.vue?vue&type=script&lang=js&"
export * from "./ArchiveOpenOrder.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveOpenOrder.vue?vue&type=style&index=0&id=10969765&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10969765",
  null
  
)

export default component.exports